/* src/app/webhook-creator/webhook-creator/webhook-creator.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.wc {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  position: relative;
  font-family: var(--tem-font-family);
  color: var(--tem-ink);
}
.wc__fab {
  position: absolute;
  z-index: 100;
  right: 30px;
  bottom: 40px;
}
.wc-filter {
  margin: var(--tem-space-2) var(--tem-space-3) 0;
  flex-shrink: 0;
}
.wc-filter__desc {
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
  margin-right: var(--tem-space-2);
}
.wc-filter__icon {
  color: var(--tem-muted);
}
.wc-filter__icon--active {
  color: var(--tem-warn);
}
.wc-filter__grid {
  display: flex;
  flex-direction: column;
  gap: var(--tem-space-2);
}
.wc-filter__line {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: var(--tem-space-2);
  width: 100%;
}
.wc-filter__search {
  flex: 1 1 100%;
}
.wc-filter__field {
  flex: 1 1 160px;
  min-width: 160px;
  display: block;
}
.wc-filter__select {
  width: 100%;
}
.wc__divider {
  margin: var(--tem-space-2) 0;
  flex-shrink: 0;
}
.wc__spin {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.wc__spin ::ng-deep .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.wc-scroll {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: auto;
  padding: var(--tem-space-3);
}
.wc-card {
  display: flex;
  flex-direction: column;
  height: 250px;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  background: var(--tem-surface);
  box-shadow: var(--tem-shadow);
  overflow: hidden;
  transition: border-color 0.2s ease;
}
.wc-card:hover {
  border-color: var(--tem-deep);
}
.wc-card__header {
  display: flex;
  align-items: center;
  gap: var(--tem-space-2);
  padding: var(--tem-space-2) var(--tem-space-3);
  border-bottom: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
  flex-shrink: 0;
}
.wc-card__title {
  font-size: var(--tem-fs-lg);
  font-weight: 600;
  color: var(--tem-ink);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  flex: 1;
}
.wc-card__public {
  color: var(--tem-accent);
  flex-shrink: 0;
}
.wc-card__body {
  flex: 1;
  min-height: 0;
  position: relative;
  padding: var(--tem-space-3);
  font-size: var(--tem-fs-md);
  color: var(--tem-ink);
}
.wc-card__body p {
  margin: 0 0 var(--tem-space-1);
}
.wc-card__icon {
  font-size: 45px;
  position: absolute;
  right: var(--tem-space-2);
  bottom: var(--tem-space-2);
  color: var(--tem-muted);
}
.wc-card__actions {
  display: flex;
  align-items: center;
  gap: var(--tem-space-2);
  padding: var(--tem-space-1) var(--tem-space-2);
  border-top: 1px solid var(--tem-border);
  flex-shrink: 0;
}
.wc-card__spacer {
  flex: 1;
}
.wc-menu__icon {
  margin-right: var(--tem-space-2);
}
.wc-summary {
  width: 100%;
  display: flex;
  padding: var(--tem-space-1);
  border-top: 1px solid var(--tem-border);
  color: var(--tem-muted);
  font-size: var(--tem-fs-sm);
  flex-shrink: 0;
}
.wc-summary__total {
  padding-left: var(--tem-space-3);
}
.wc-summary__spacer {
  flex-grow: 1;
}
.wc-summary__lines {
  padding-right: var(--tem-space-3);
}
.wc-edit {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}
.wc-edit__toolbar {
  display: flex;
  align-items: center;
  gap: var(--tem-space-3);
  padding: var(--tem-space-2) var(--tem-space-3);
  margin-bottom: var(--tem-space-1);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface-2);
  flex-shrink: 0;
}
.wc-edit__title {
  font-size: var(--tem-fs-lg);
  font-weight: 600;
  color: var(--tem-ink);
}
/*# sourceMappingURL=webhook-creator.component.css.map */
